export { default as PriceLabelContainer } from './PriceLabelContainer'
export { default as RegularPriceWrapper } from './RegularPriceWrapper'
export { default as PriceWrapper } from './PriceWrapper'
export { default as CashBack } from './CashBack'
export { default as InstallmentsWrapper } from './InstallmentsWrapper'



// WEBPACK FOOTER //
// ./src/Catalog/Availability/PriceLabel/index.js